import React from 'react';
import { DomainPropType, VictoryChart, VictoryStyleInterface } from 'victory';
import { QualaVictoryTheme } from '.';
import { isSmall } from '../../lib/helpers';

interface IQualaChart {
  children: React.ReactNode;
  domain?: DomainPropType;
  short?: boolean;
}

const QualaChart: React.FC<IQualaChart> = ({ children, domain, short }) => {
  const small = isSmall();
  const height = short ? 90 : 120;
  const width = small ? 400 : 428;

  return (
    <div style={{ maxWidth: width }}>
      <VictoryChart
        height={height}
        width={width}
        padding={{ top: 0, bottom: 21, left: 0, right: 0 }}
        domain={domain}
        domainPadding={{ x: 20, y: [25, 0] }}
        theme={QualaVictoryTheme}
        scale={{ x: 'time' }}
      >
        {children}
      </VictoryChart>
    </div>
  );
};

export default QualaChart;
